import sanitizer from "string-sanitizer";

export const sanitizeString = (str) => {
  return str
    .trim()
    .split(" ")
    .map((strPiece) => sanitizer.sanitize(strPiece))
    .join(" ");
};

export default { sanitizeString };
